export { View as CompanyCredentials } from './view'
